import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface TabItem {
  id: string;
  icon: string;
  activeIcon: string;
  label: string;
  path: string;
}

const tabs: TabItem[] = [
  { id: 'home', icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill', label: '首页', path: '/' },
  { id: 'purchase', icon: 'ri-shopping-cart-2-line', activeIcon: 'ri-shopping-cart-2-fill', label: '进货', path: '/purchase' },
  { id: 'profile', icon: 'ri-user-3-line', activeIcon: 'ri-user-3-fill', label: '我的', path: '/profile' },
];

export default function TabBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(() => {
    const matched = tabs.find(t => t.path === location.pathname);
    return matched?.id || 'home';
  });

  const handleTabClick = (tab: TabItem) => {
    setActiveTab(tab.id);
    navigate(tab.path);
  };

  return (
    <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-mobile z-50">
      {/* Shadow overlay */}
      <div className="absolute -top-3 left-0 right-0 h-3 bg-gradient-to-t from-black/5 to-transparent pointer-events-none" />
      
      <div className="bg-white/95 backdrop-blur-lg border-t border-background-100/80 shadow-[0_-4px_20px_rgba(0,0,0,0.06)]">
        <div className="flex items-center justify-around h-16 px-2">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab)}
                className="relative flex flex-col items-center justify-center gap-1 w-16 h-full cursor-pointer"
              >
                {/* Active indicator dot */}
                {isActive && (
                  <div className="absolute -top-0.5 w-6 h-1 bg-primary-500 rounded-full" />
                )}
                
                <div
                  className={`w-10 h-10 flex items-center justify-center rounded-xl transition-all duration-300 ${
                    isActive
                      ? 'bg-primary-50 text-primary-500'
                      : 'text-foreground-400'
                  }`}
                >
                  <i
                    className={`${isActive ? tab.activeIcon : tab.icon} text-xl transition-all duration-300 ${
                      isActive ? 'scale-110' : 'scale-100'
                    }`}
                  />
                </div>
                <span
                  className={`text-xs font-medium transition-all duration-300 ${
                    isActive
                      ? 'text-primary-500 font-semibold'
                      : 'text-foreground-400'
                  }`}
                >
                  {tab.label}
                </span>
              </button>
            );
          })}
        </div>
        
        {/* Safe area */}
        <div className="h-2 bg-white/95" />
      </div>
    </div>
  );
}